<template>
  <div class="RepairOrderStatistics">
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '100%' }">
      <div class="headline" slot="title">
        <div class="vertical"></div>工单统计
      </div>
      <div class="content">
        <Statistical-graph :data="StatisticsList"></Statistical-graph>
      </div>
    </a-card>
  </div>
</template>

<script>
function delMonth(data) {
   if(data.substr(0,1)=='0'){
     return data.substr(1,2)+'月'
   }else{
          return data+'月'
   }
}
import StatisticalGraph from './component/Statistical-graph.vue'
export default {
  components: {
    StatisticalGraph
  },
  data() {
    return {
      StatisticsList: [],
      color:[
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.5,
              color: '#DEEBFF' // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#8BB9FE' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        },
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#FFFFFF' // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: '#7EE7E4' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      ],
      lineColor:['#1377F4','#01CEBF'],

    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      // 工单统计
      this.$http.get('/pipe-network/inspection/workbench/year-num').then(res => {
        
        const list = res.data
        var xdata = []
        var series = []
        list.map((item, index) => {
          // item.time=item.time.substring(5,item.time.length)

          let sData = []
          item.yearNumVos.map(g => {
            if (index == 0) {
              xdata.push(delMonth(g.month.substr(5,7)) )
            }
            sData.push(g.num)
          })
          let sObj = {
            data: sData,
            type: 'line',
            name: item.year,
                symbol: 'none',
                 smooth: true,
            areaStyle: {
              color: this.color[index]
            },
            lineStyle: {
              color: this.lineColor[index]
            }
          }
          series.push(sObj)
        })
        this.StatisticsList = {
          xdata: xdata,
          series: series,
          color: ['#3488ED', '#07C2B2'],
          grid: {
            x: '8%', // 左侧与y轴的距离
            y: '18%', // top部与x轴的距离
            x2: '2%', // 右侧与y轴的距离
            y2: '14%' // bottom部与x轴的距离
          }
        }
        console.log(this.StatisticsList)
      })
    }
  }
}
</script>

<style lang='less' scoped>
.RepairOrderStatistics {
  margin: 5% 0;
}
.vertical {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.headline {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
.cardHead {
  height: 48px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
  border-bottom: 1px solid #e8e8e8;
  .radiusTitleStatis {
    float: left;
    // width: 100px;
    // height: 21px;
    line-height: 21px;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 15px;
    color: #101010;
    letter-spacing: 0.63px;
    font-weight: 600;
  }
  .extra {
    width: 40%;
    min-width: 120px;
  }
}
/deep/ .ant-card-body {
  padding: 0;
}

.content {
  width: 100%;
  height: 200px;
}
</style>
